var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCalendarCheck = function SvgIconCalendarCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.06 12.728a1 1 0 0 0-1.37-1.456L11 14.75l-1.687-1.6a1 1 0 1 0-1.376 1.452l2.372 2.25a1 1 0 0 0 1.374.002z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.5.875a1 1 0 0 1 1 1v.875h2c.966 0 1.75.784 1.75 1.75v15a1.75 1.75 0 0 1-1.75 1.75h-15a1.75 1.75 0 0 1-1.75-1.75v-15c0-.966.784-1.75 1.75-1.75h2v-.875a1 1 0 0 1 2 0v.875h7v-.875a1 1 0 0 1 1-1m2.75 3.875v2.5H4.75v-2.5zm0 4.5H4.75v10h14.5z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconCalendarCheck;